class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  async onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    // Check if the variant product is on the product page
    this.isPdpContext = window.location.pathname === this.dataset.url;

    if (!this.currentVariant) {
      // Set unavailable when there is no current variant found and stop the script
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
      this.hideVariantStock();
      return;
    }

    this.updateVariantInput();
    // Updates pdp interface and set url
    if (this.isPdpContext) {
      this.updateMedia();
      this.updateURL();
      this.dispatchVariantChange();
    }

    this.renderProductInfo();
    this.updateBuyButton();
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          if (!this.options[index]) {
            return true;
          }
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  dispatchVariantChange() {
    document.dispatchEvent(
      new CustomEvent('variant-change', {
        bubbles: true,
        variant: this.currentVariant,
        detail: {
          variant: this.currentVariant,
        },
      })
    );
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    parent.prepend(newMedia);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /**
   * renderProductInfo
   * @description Fetch product based on variant
   * @returns {void}
   */
  async renderProductInfo() {
    try {
      const response = await fetch(
        `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
      );

      if (response.status !== 200) {
        throw new Error('Response status not 200');
      }

      const responseText = await response.text();
      const html = new DOMParser().parseFromString(responseText, 'text/html');

      // Set product variant price
      const id = `price-${this.dataset.section}`;
      const source = html.getElementById(id);
      const destination = document.getElementById(id);
      if (source && destination) destination.innerHTML = source.innerHTML;
      document.getElementById(`price-${this.dataset.section}`)?.classList.remove('hidden');

      // Update the inventory quantity hidden input
      const inventoryQtyDestination = document
        .querySelector(`#product-form-${this.dataset.section}`)
        .querySelector('input[name="inventory_quantity"]');
      const inventoryQtySource = html
        .querySelector(`#product-form-${this.dataset.section}`)
        .querySelector('input[name="inventory_quantity"]');
      if (inventoryQtyDestination && inventoryQtySource) {
        inventoryQtyDestination.value = inventoryQtySource.value;
      }

      // Update variant stock indicator
      const newVariantStock = html.querySelector('[data-product="variant-stock"]');
      const oldVariantStock = document.querySelector('[data-product="variant-stock"]');
      if (newVariantStock && oldVariantStock) {
        oldVariantStock.innerHTML = newVariantStock.innerHTML;
        this.showVariantStock();
      }

      // Update variant usp items
      const newUspItems = html.querySelectorAll('[data-product="usp"]');
      const oldUspItems = document.querySelectorAll('[data-product="usp"]');
      if (newUspItems.length && oldUspItems.length) {
        oldUspItems.forEach((oldUsp, index) => {
          oldUsp.innerHTML = newUspItems[index].innerHTML;
        });
      }

      // Update variant card info, used on the pdp upsell product
      const newCardInfo = html.getElementById(`card-info-${this.dataset.section}`);
      const oldCardInfo = document.getElementById(`card-info-${this.dataset.section}`);
      // console.log(newCardInfo, oldCardInfo);
      if (newCardInfo && oldCardInfo) {
        oldCardInfo.innerHTML = newCardInfo.innerHTML;
      }
    } catch (error) {
      console.error(error);
    }
  }

  hideVariantStock() {
    const variantStock = document.querySelector('[data-product="variant-stock"]');
    if (!variantStock) return;
    variantStock.classList.add('hidden');
  }

  showVariantStock() {
    const variantStock = document.querySelector('[data-product="variant-stock"]');
    if (!variantStock) return;
    variantStock.classList.remove('hidden');
  }

  /**
   * toggleAddButton
   * @param {Boolean} disable
   * @param {String} text
   * @param {Boolean} modifyClass
   * @returns {void}
   */
  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]');
    const addButtonText = addButton.querySelector('[data-add-to-cart-button-text]');

    if (!addButton && !addButtonText) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  updateBuyButton() {
    if (this.currentVariant) {
      if (this.currentVariant.available) {
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.addToCart);
      } else {
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      }
    }
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector('[name="add"]')
      .querySelector('[data-add-to-cart-button-text]');
    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    // document.getElementById(`price-${this.dataset.section}`)?.classList.add('hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

if (!customElements.get('variant-selects')) {
  customElements.define('variant-selects', VariantSelects);
}

class VariantPicker extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const select = this.querySelector('select');
    const value = select.value;
    this.selectedId = parseInt(value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return variant.id === this.selectedId;
    });
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.updateOptions();
    this.updateMasterId();
    this.highlightOptions();
  }

  onVariantChange() {
    super.onVariantChange();
    this.highlightOptions();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }

  /*
   * Check for each option value if the other one/two selected variant options are available
   */
  highlightOptions() {
    // If no selected element make all available
    let selectedElement = event
      ? event.target
      : this.querySelector('[data-option-group] input[checked]');
    if (!selectedElement) {
      this.querySelectorAll('[data-option-group]').forEach((option) => {
        option.querySelectorAll('[data-option]').forEach((optionEl) => {
          let label = optionEl.querySelector('[data-option-label]');
          label.classList.remove('option-is-disabled');
        });
      });
      return;
    }

    // Loop over option groups
    this.querySelectorAll('[data-option-group]').forEach((option) => {
      // Get index from option group (1, 2 or 3)
      const optionIndex = parseInt(option.dataset.optionGroup);

      // Create compare options from group, remove selected option based on index
      const compareOptions = [...this.options].filter((option, index) => index != optionIndex);

      // Loop over possible values for option group
      option.querySelectorAll('[data-option]').forEach((optionEl) => {
        let label = optionEl.querySelector('[data-option-label]'),
          input = optionEl.querySelector('[data-option-input]'),
          value = input.value;

        // Match option availability and check if the two current options are available for value
        let match = this.getVariantData().filter((variant) => {
          // Get available variants where the current option index is the option value
          if (variant.options[optionIndex] == value && variant.available) {
            // Create variant options, remove option based on option value
            const variantOptions = [...variant.options].filter(
              (option, index) => index != optionIndex
            );

            // Check if compare options is the same as variant options
            return variantOptions.every(
              (item, index) => item.toLowerCase() === compareOptions[index].toLowerCase()
            );
          }

          return false;
        });

        // Debug current index, current value, compare options and match

        // Enable disable variant options
        label.classList.toggle('option-is-disabled', match.length == 0);
      });
    });
  }
}

if (!customElements.get('variant-radios')) {
  customElements.define('variant-radios', VariantRadios);
}
